import { NGX_MAT_DATE_FORMATS, NgxMatDateAdapter, NgxMatDatetimePickerModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CustomDateAdapter } from '../../../../../shared/custom-date-adapter';

export const IMPORTS = [
    CommonModule,
    FormsModule,
    NgxMatDatetimePickerModule,
    MatDatepickerModule,
    NgxMatMomentModule,
    NgxMatTimepickerModule
];

export const PROVIDERS = [
    {
        provide: NGX_MAT_DATE_FORMATS,
        useValue: {
            parse: {
                dateInput: "DD/MM/YYYY"
            },
            display: {
                dateInput: "DD/MM/YYYY",
                monthYearLabel: "MMM YYYY",
                dateA11yLabel: "LLL",
                monthYearA11yLabel: "MMMM YYYY"
            }
        }
    },
    { provide: NgxMatDateAdapter, useClass: CustomDateAdapter },
];
